/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
export default class Newsletter {
	static initClass() {
		this.prototype.$busy = false;
		this.prototype.$timer = false;
	}

	constructor() {
		this.initEvents();
	}

	initEvents() {
		//TODO: Als men te snel klikt dan krijg je een internal server error.
		$('.newsletter__item label').on('click', e => {
			if (this.$busy) {
				return e.preventDefault();
			}
		});

		//click event on newsletter checkbox
		return $('.newsletter__item input[type="checkbox"]').on('change', e => {
			let checked;
			this.$busy = true;
			// Problem with Safari: Chrome check before on 'change' && safari after
			const amount_checked = $(".newsletter input:checkbox:checked").length;
			console.log(amount_checked);
			const value = $(e.target).attr('value');
			if ((amount_checked > 0) || confirm($('#newsletter_container').attr('data-subscribeall-text'))) {
				checked = false;
				if ($(e.target).is(':checked')) {
					checked = true;
				}
				$.ajaxSetup({ headers: { 'X-CSRF-Token': $('input[name="_token"]').val() } });
				const url = window.site.current_url;

				return $.ajax({
					type: 'POST',
					url,
					dataType: 'json',
					data: {
						brand_id: value,
						optin: checked
					},
					success: data => {
						this.$busy = false;
						if ($('.notification')[0]) {
							$('.notification').remove();
							clearTimeout(this.$timer);
						}

						const notification = $(data.notification).hide();

						$('body').prepend(notification);
						notification.slideDown(window.site.notification_time);

						if ($('.notification:not(.dont_autoclose)')[0]) {
							return this.$timer = setTimeout((() =>
								$('.notification').slideUp(function () {
									return $(this).remove();
								})
							), window.site.notification_time);
						}
					},
					error: (xhr, textStatus, error) => {
						this.$busy = false;
						$('.notification').remove();
						clearTimeout(this.$timer);
						const notification = `<div class="notification padding notification--error"><span>${window.site.error}</span></div>`;
						$('body').prepend(notification);
						if ($('.notification:not(.dont_autoclose)')[0]) {
							return this.$timer = setTimeout((() =>
								$('.notification').slideUp(function () {
									return $(this).remove();
								})
							), window.site.notification_time);
						}
					}
				});
			} else {
				$(`#${e.target.id}`)[0].checked = true;
				return this.$busy = false;
			}
		});
	}
}

